import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabSetor = '/service/contabilidade/administracaoRH/'

class SetorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getSetor() {
        return this.conex.get(urlTabSetor + 'retornaTodosSetor/')
    }
}

export default SetorService
